export const dropZoneStyles = {
  width: "100%",
  "& .dropzone-root": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "79px",
    border: "1px dashed #c6c6c6",
    borderRadius: "5px",
    padding: "8px 16px",
    cursor: "pointer",
    outline: "none",
  },
  "& .dropzone-root:focus-visible": {
    borderColor: "#1976d2",
  },
  "& .dropzone-text": {
    width: "100%",
    textAlign: "center",
  },
  "& .dropzone-text .MuiTypography-root": {
    fontSize: "14px",
    whiteSpace: "pre-line",
  },
};
